import { addMissingDates } from 'src/components/therapyPlanning_2.0/commonComponent/converttherapyPlaningResponse';
import {
  getFrequencyType,
  getTotalFrequencyData,
  replaceDataByKey,
  replaceDataOfSummary,
} from 'src/components/therapyPlanning_2.0/commonComponent/updateSingleCellData';
import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  GET_THERAPY_PLANNING_SUMMARY_SUCCESS_2_0,
  GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0,
  GET_THERAPY_PLANNING_SUMMARY_FAILURE_2_0,
  GET_THERAPY_PLANNING_SUMMARY_LOADING_2_0,
  GET_THERAPY_PLANNING_SUMMARY_RESET_2_0,
} = therapyPlanningAction;

const intitialstate: any = {
  response: null,
  loading: false,
  isTherapyPlanningSummary: false,
  therapyPlanningSummaryWithDate: null,
  requestDiscipline: null,
  frequencyData: null,
  isRequiredPlanning: false,
};

export const getTherapyPlanningSummaryReducer_2_0 = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_THERAPY_PLANNING_SUMMARY_SUCCESS_2_0: {
      if (action?.payload?.source === 'GET_WEEKLY') {
        return {
          ...state,
          response: action.payload,
          loading: false,
          isRequiredPlanning: action?.payload?.response?.data?.isRequiredPlanning,
          requestDiscipline: null,
          isTherapyPlanningSummary: true,
          frequencyData: getTotalFrequencyData(action?.payload?.response?.data),
          therapyPlanningSummaryWithDate: addMissingDates(
            action?.payload?.requestPayload?.startDate,
            action?.payload?.requestPayload?.endDate,
            action?.payload?.response?.data ? action?.payload?.response?.data : {}
          ),
        };
      } else {
        return {
          ...state,
          loading: false,
          response: action.payload,
          isTherapyPlanningSummary: true,
          isRequiredPlanning: action?.payload?.response?.data?.isRequiredPlanning,
          frequencyData: replaceDataByKey(
            state?.frequencyData,
            action?.payload?.response?.data,
            getFrequencyType(action?.payload?.therapyType)
          ),
          therapyPlanningSummaryWithDate: replaceDataOfSummary(
            state?.therapyPlanningSummaryWithDate,
            action?.payload?.therapyType,
            action?.payload?.response?.data,
            action?.payload?.requestPayload?.startDate,
            action?.payload?.requestPayload?.endDate
          ),
        };
      }
    }

    case GET_THERAPY_PLANNING_SUMMARY_FAILURE_2_0:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isTherapyPlanningSummary: false,
        therapyPlanningSummaryWithDate: null,
        requestDiscipline: null,
      };
    case GET_THERAPY_PLANNING_SUMMARY_LOADING_2_0:
      return {
        ...state,
        loading: true,
        requestDiscipline: action?.requestDiscipline,
      };

    case GET_THERAPY_PLANNING_SUMMARY_RESET_2_0:
      return intitialstate;

    default:
      return state;
  }
};
